import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { OperationLinkOptions } from '../../model/operation-link.js';
import { bankTransactionQueries } from './bank-transaction-queries.js';

export const useOperationLinkOptionsQuery = (
  operationId: string,
): UseQueryResult<OperationLinkOptions> =>
  useQuery(bankTransactionQueries.linkOptions(operationId));
